/**
 * Field Type Components Index
 *
 * Exports all field type-specific components and provides a mapping
 * from extension field type IDs to their corresponding components.
 */

import { EXTENSION_FIELD_TYPE_IDS } from "../../../utils/extensionFieldUtils";
import { CurrencyFieldEditor } from "./CurrencyFieldEditor";
import { DateFieldEditor } from "./DateFieldEditor";
import { DefaultFieldEditor } from "./DefaultFieldEditor";
import { EnumerationFieldEditor } from "./EnumerationFieldEditor";
import { FloatFieldEditor } from "./FloatFieldEditor";
import { IntegerFieldEditor } from "./IntegerFieldEditor";
import { PercentileFieldEditor } from "./PercentileFieldEditor";
import { TextFieldEditor } from "./TextFieldEditor";

// Export all field type components
export {
  IntegerFieldEditor,
  FloatFieldEditor,
  TextFieldEditor,
  EnumerationFieldEditor,
  DateFieldEditor,
  PercentileFieldEditor,
  CurrencyFieldEditor,
  DefaultFieldEditor,
};

/**
 * Mapping from extension field type IDs to their corresponding components
 */
export const FieldTypeComponents = {
  [EXTENSION_FIELD_TYPE_IDS.INTEGER]: IntegerFieldEditor,
  [EXTENSION_FIELD_TYPE_IDS.FLOAT]: FloatFieldEditor,
  [EXTENSION_FIELD_TYPE_IDS.TEXT]: TextFieldEditor,
  [EXTENSION_FIELD_TYPE_IDS.ENUMERATION]: EnumerationFieldEditor,
  [EXTENSION_FIELD_TYPE_IDS.PERCENTILE]: PercentileFieldEditor,
  [EXTENSION_FIELD_TYPE_IDS.CURRENCY_USD]: CurrencyFieldEditor,
  [EXTENSION_FIELD_TYPE_IDS.DATE]: DateFieldEditor,
  // Default component for unknown field types
  default: DefaultFieldEditor,
} as const;
